var Cortona3DSolo = require('solo');
var checkConfigureOptions = require('app').checkConfigureOptions;
var expand = require('lib/util').expand;

window.Module = expand(window.Module || {}, Cortona3DSolo.core || {});
if (typeof Module.Tiramisu !== 'object') Module.Tiramisu = {};

var Arguments = {
    toModule: function () {
        Module.arguments = [];
        for (var key in this) {
            if (this.hasOwnProperty(key) && typeof this[key] !== 'function') {
                Module.arguments.push(key);
                Module.arguments.push(String(this[key]));
            }
        }
    },
    features: 0
};

function TiramisuLoadingError(message) {
    this.name = 'TiramisuLoadingError';
    this.message = message || '';
}
TiramisuLoadingError.prototype = Object.create(Error.prototype);
TiramisuLoadingError.prototype.constructor = TiramisuLoadingError;

function load(coreName) {
    try {
        var xhr = new window.XMLHttpRequest();

        if (xhr.overrideMimeType) {
            xhr.overrideMimeType('text/javascript');
        }

        var coreURL = coreName || (checkConfigureOptions(Cortona3DSolo.app.ENABLE_VRML_TEXT_NODE) ? 'Cortona3DSoloCoreText.js' : 'Cortona3DSoloCore.js');

        coreURL = Module.locateFile(coreURL);        

        xhr.open("GET", coreURL, true);
        xhr.onerror = function (e) {
            if (Module.onprogress) {
                Module.onprogress({
                    loaded: 0,
                    total: -1,
                    type: e.type
                });
            }
            Cortona3DSolo.emit('core.onError', new Error(coreURL + ' ' + xhr.statusText));
        };
        xhr.onprogress = function (e) {
            if(Module.onprogress) {
                Module.onprogress(e);
            }
        };
        xhr.onload = function (e) {
            if (Module.onprogress) {
                Module.onprogress({
                    loaded: 0,
                    total: -1,
                    type: e.type
                });
            }

            if (xhr.status === 200 || xhr.status === 0) {
                var script = document.createElement('script');
                var DOMURL = window.URL || window.webkitURL || window;
                var url = DOMURL.createObjectURL(new Blob([xhr.response]));
                script.onload = function () {
                    DOMURL.revokeObjectURL(url);
                    Cortona3DSolo.emit('core.onLoad');
                    window.addEventListener('error', function (messageOrEvent, source, lineno, colno, error) {
                        if (source == url || messageOrEvent.filename == url) {
                            Cortona3DSolo.emit('core.onError', error || messageOrEvent);
                        }
                    });
                };
                script.onerror = function (e) {
                    DOMURL.revokeObjectURL(url);
                    Cortona3DSolo.emit('core.onError', new Error(coreURL + ' ' + e));
                };
                script.src = url;
                document.body.appendChild(script);
            } else {
                Cortona3DSolo.emit('core.onError', new Error(coreURL + ' ' + xhr.statusText));
            }
        };
        xhr.send(null);
    } catch (e) {
        throw new TiramisuLoadingError(e.message || e);
    }
}

module.exports = {
    Arguments: Arguments,
    load: load
};